import type { PaymentMethodTokenDetails } from '@anchorbase/pillar-sdk';

type PaymentMethodDescriptorInput = {
    payment_method_token_details: PaymentMethodTokenDetails;
};

type PaymentMethodDescriptor = Readonly<{
    title: string;
    subtitle: string;
}>;

export function describePaymentMethod(
    paymentMethod: PaymentMethodDescriptorInput
): PaymentMethodDescriptor {
    const details = paymentMethod.payment_method_token_details;
    switch (details.payment_rail) {
        case 'CREDIT_CARD':
        case 'DEBIT_CARD':
            return {
                title: `${details.card_brand} ${details.masked_pan}`,
                subtitle: details.cardholder_name,
            };
        case 'ACH':
            return {
                title:
                    details.bank_name !== undefined && details.bank_name.length > 0
                        ? `${details.bank_name} ${details.masked_account_number}`
                        : details.masked_account_number,
                subtitle: details.account_holder_name,
            };
    }
}
